import { render } from "./Scene.vue?vue&type=template&id=24d9eedc&scoped=true"
import script from "./Scene.vue?vue&type=script&lang=js"
export * from "./Scene.vue?vue&type=script&lang=js"

import "./Scene.vue?vue&type=style&index=0&id=24d9eedc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d9eedc"]])

export default __exports__